<!--站点列表-->
<template>
  <div class="zdlb">
    <div class="zdlb-top">
      <van-search
        v-model="search"
        show-action
        placeholder="请输入站点"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div class="zdlb-body">
      <div class="tw-index-history-text">站点列表</div>
      <div style="height: calc(100% - 25px);overflow: auto;">
        <div class="tw-index-history-list" v-if="zsStationList.length > 0">
          <div
            class="tw-index-history-list-item"
            v-for="(item, index) in zsStationList"
            :key="index"
          >
            <div
              class="tw-index-history-list-item-name"
              @click.stop="handleItemClick(item.station_alias)"
            >
              {{ item.station_alias }}
            </div>
          </div>
        </div>
        <div
          v-else
          style="text-align:center;font-size:16px;line-height:100px;color: #bfbfbf;"
        >
          无此站点
        </div>
      </div>
    </div>
    <div class="zdlb-bottom">
      <div class="tw-index-history-text">历史记录</div>
      <div style="height: calc(100% - 25px);overflow: auto;">
        <div class="tw-index-history-list">
          <div
            class="tw-index-history-list-item"
            v-for="(item, index) in historyList"
            :key="index"
          >
            <div
              class="tw-index-history-list-item-name"
              @click.stop="handleItemClick(item.station)"
            >
              {{ item.station }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import { getHistory, getStationList } from 'api/indexAPI'
export default {
  name: 'SiteList',
  data() {
    return {
      search: '',
      historyList: [],
      xlzdList: [],
      stationList: [],
      zsStationList: [],
      type: '',
      begin: '',
      end: ''
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.begin = this.$route.query.begin
    this.end = this.$route.query.end
    this.getHistory()
    this.getStationList()
  },
  methods: {
    onCancel() {
      window.history.go(-1)
    },
    onSearch() {
      this.searchWatch()
    },
    //获取历史记录
    getHistory() {
      const params = new URLSearchParams()
      params.append('openid', this.$store.state.user.openid)
      params.append('pageSize', '20')
      getHistory(params).then(res => {
        this.historyList = res.data.data
      })
    },
    //获取所有站点列表
    getStationList() {
      getStationList().then(res => {
        this.stationList = res.data.data
        _.each(res.data.data, item => {
          this.xlzdList.push({ value: item.station_alias })
        })
        this.searchWatch(this.search)
      })
    },
    //监听输入框内容
    searchWatch(val) {
      if (val == '') return (this.zsStationList = this.stationList)
      this.zsStationList = _.filter(this.stationList, item => {
        return item.station_alias.indexOf(val) >= 0
      })
    },
    //item点击事件
    handleItemClick(val) {
      this.type == 'begin' ? (this.begin = val) : (this.end = val)
      this.$router.push({
        path: '/',
        query: {
          type: this.type,
          begin: this.begin,
          end: this.end
        }
      })
    }
  },
  watch: {
    search: {
      handler(newName, oldName) {
        this.searchWatch(newName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zdlb {
  height: 100%;
  &-top {
    height: 60px;
  }
  &-body {
    height: calc(60% - 30px);
  }
  &-bottom {
    height: calc(40% - 30px);
  }
}
</style>
